import { CssBaseline } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Route, Router, Switch } from 'react-router-dom';
import './App.css';
import Login from './containers/Login/Login';
import ProtectedRoutes from './containers/ProtectedRoutes/ProtectedRoutes';
import MySnackbar from './containers/Snackbar/Snackbar';
import { IState } from './models/states';
import { authCheckState } from './store/actions/userActions';
import history from './utilities/history';
interface IAppDispatchProps {
  authCheckState: () => void;
}
type IAppProps = IAppDispatchProps & IAppStateProps;
interface IAppState {
  isExistToken: boolean;
  isConfigLoaded: boolean;
}
declare let jwplayer: any;

class App extends React.Component<IAppProps, IAppState> {
  constructor(props: IAppProps) {
    super(props);
    this.state = {
      isExistToken: false,
      isConfigLoaded: false
    };
  }
  loadScript = (jsScript: string) => {
    const script = document.createElement('script');

    script.src = jsScript;
    script.async = false;

    document.body.appendChild(script);
  };
  componentWillMount() {
    const baseURL = window.location.origin;
    this.loadScript(`${baseURL}/jwplayer/jwplayer.js`);
    this.loadScript(`${baseURL}/webrtc/adapter.min.js`);
    this.loadScript(`${baseURL}/webrtc/janus.js`);
    this.loadScript(`${baseURL}/webrtc/webrtcStreaming.js`);
    axios
      .get('/config.json')
      .then(res => {
        globalThis.UI_CONFIG = res.data;
        this.setState({ isConfigLoaded: true });
        this.props.authCheckState();
      })
      .catch(err => console.log(err));
  }

  public render() {
    return (
      <React.Fragment>
        <CssBaseline />
        {this.state.isConfigLoaded ? (
          <Router history={history}>
            <div className="App">
              <Switch>
                <Route path="/login" component={Login} />
                {this.props.authStatus !== 1 ? (
                  this.props.authStatus === -1 ? (
                    <Redirect to="/login" />
                  ) : null
                ) : (
                  <Route path="/" component={ProtectedRoutes} />
                )}
              </Switch>
              <MySnackbar />
            </div>
          </Router>
        ) : (
          <Typography>Loading...</Typography>
        )}
      </React.Fragment>
    );
  }
}

interface IAppStateProps {
  authStatus: number;
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    authCheckState: () => dispatch(authCheckState())
  };
};
const mapStateToProps = (state: IState) => {
  return {
    authStatus: state.user.authStatus
  };
};

export default connect<IAppStateProps, IAppDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(App);
